import axios from "axios";

export const fetchParkingData = async () => {
  const response = await axios.get("/ParkingData/list");
  return response;
};
